import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { UniqueMechanism } from './components/UniqueMechanism';
import { ChapterPreview } from './components/ChapterPreview';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { BonusSection } from './components/BonusSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-light font-sans text-brand-dark selection:bg-brand-sage selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPoints data-id="element-2" />
      <UniqueMechanism data-id="element-3" />
      <ChapterPreview data-id="element-4" />
      <WhoIsThisFor data-id="element-5" />
      <BonusSection data-id="element-6" />
      <FinalCTA data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}